import { isFinite } from 'lodash';
import numeral from 'numeral';

import { DEFAULT_PRECISION } from '@funnels/constants';

export default function formatNumberToStringPrecision(value?: number, precision: number = DEFAULT_PRECISION) {
  const precisionString = '0'.repeat(precision);
  return isFinite(value) ? numeral(value).format(`0,0[.]${precisionString}`) : '0';
}
